import en from './en';

export default {
    en: en
};


// WEBPACK FOOTER //
// ./node_modules/@int/signature/lib/i18n/index.js